import { useContext } from "react";
import { Menu } from "react-admin";
import QueueIcon from "@mui/icons-material/Queue";
import { AuJobQueuesAdminPath } from "@arrowsup/platform-dtos";
import { AccessTokenContext } from "../../logic/auth/access-token-context";
import { createBackendSession } from "../../logic/auth/backend-session";
import { PlatformUiEnvToHostMap } from "../../logic/data-provider/platform-ui-env-to-host-map";
import { usePlatformUiEnv } from "../../logic/env/use-platform-ui-env";

/** Opens the backend's job queue admin (bull-board) in a new tab. */
export const JobQueuesMenuItem = () => {
  const env = usePlatformUiEnv();
  const getAccessToken = useContext(AccessTokenContext).getAccessToken;
  // Trailing slash: bull-board serves its UI under this base path.
  const url = `${PlatformUiEnvToHostMap[env]}${AuJobQueuesAdminPath}/`;

  const open = (event: React.MouseEvent) => {
    event.preventDefault();
    // Open the tab during the click so popup blockers allow it, then navigate
    // once the session cookie exists.
    const tab = window.open("", "_blank");

    if (!tab) {
      return;
    }

    tab.opener = null;

    const navigate = async () => {
      try {
        await createBackendSession(env, getAccessToken);
        tab.location.href = url;
      } catch (e) {
        tab.close();
        alert(`Unable to open job queues: ${String(e)}`);
      }
    };

    void navigate();
  };

  return (
    <Menu.Item
      to="/job-queues"
      onClick={open}
      primaryText="Job queues"
      leftIcon={<QueueIcon />}
    />
  );
};
